const imgTeamUiUxMain = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingUiux1 = "./assets/figma/c357b1ec-13ab-4698-9e07-c30cb1b6c76c.png";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgArrow5 = "./assets/figma/86fee700-6c89-4ef3-a41a-21b7518ecb91.svg";
const imgEllipse30 = "./assets/figma/763a2410-be67-44dc-b492-c69847dfcac8.svg";
const imgEllipse31 = "./assets/figma/18b8827b-3a68-464b-82a9-ff9b66d5260a.svg";
const imgEllipse32 = "./assets/figma/cd9d173a-1776-4d44-8a1f-2c5baff90924.svg";
const imgEllipse33 = "./assets/figma/ea4783f8-352d-4f8b-aec9-f94683897408.svg";
const img1 = "./assets/figma/beaf3898-09ae-4b77-8dd1-0533e6feca91.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgEllipse37 = "./assets/figma/913dc448-4698-43da-9d8b-57b058da291a.svg";

export default function TeamUiUxMain() {
  return (
    <div className="s0 s1" data-node-id="772:310" data-name="TEAM_UI/UX_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s258 s1" src={imgTeamUiUxMain} />
      </div>
      <div className="s2 s607 s608 s265 s609" data-node-id="886:7" data-name="DINGAI_UIUX 1" />
      <div className="s2 s267 s268 s269 s270" data-node-id="772:316" data-name="image 14" />
      <div className="s259 s2 s16 s17 s24 s610 s18 s19 s611 s273 s274 s275 s276 s145 s146 s261 s278" data-node-id="772:338">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="772:339">
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s34" data-node-id="772:340">
            Ui/ux AI RECIPE
          </p>
          <div className="s46 s0 s28 s34" data-node-id="772:341">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <a className="s282 s16 s141 s17 s24 s283 s284 s18 s42 s285 s286 s287 s0 s145 s146 s28 s288 s289 s290" data-node-id="772:342" data-name="ARCHIVE3">
          <div className="s16 s17 s18 s19 s0 s28 s34" data-node-id="772:343">
            <p className="s23 s31 s32 s27 s0 s28 s29 s37 s149 s54" data-node-id="772:344">
              ARCHIVE
            </p>
            <div className="s46 s0 s28 s291" data-node-id="772:345">
              <div className="s2 s292">
                <img alt="" className="s49 s9 s1" src={imgArrow5} />
              </div>
            </div>
          </div>
        </a>
        <div className="s2 s3 s4 s150 s151" />
      </div>
      <div className="s259 s2 s16 s17 s24 s293 s612 s26 s613 s277 s297" data-node-id="772:346">
        <div className="s16 s17 s298 s18 s0 s28 s34" data-node-id="772:347">
          <div className="s0 s28 s299" data-node-id="772:348">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse30} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="772:349">
            CHATGPT
          </p>
        </div>
        <div className="s16 s17 s298 s18 s0 s28" data-node-id="772:350">
          <div className="s0 s28 s299" data-node-id="772:351">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse31} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="772:352">
            JEMINI
          </p>
        </div>
        <div className="s16 s17 s298 s18 s0 s28" data-node-id="772:353">
          <div className="s0 s28 s299" data-node-id="772:354">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse32} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="772:355">
            TRIPO
          </p>
        </div>
        <div className="s16 s17 s298 s18 s0 s28" data-node-id="772:356">
          <div className="s0 s28 s299" data-node-id="772:357">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse33} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="772:358">
            MANUS
          </p>
        </div>
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1018:172" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="1018:173">
          <div className="s111 s0 s28 s112" data-node-id="1018:174" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1018:179">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1018:180">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1018:181">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:182">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:183">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="1018:184">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:185">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:186">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="1018:187">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:188">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:189">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s259 s2 s16 s17 s24 s230 s26 s303 s277 s304" data-node-id="1018:208" data-name="TAB_TEAM">
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s304" data-node-id="1018:209" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="1018:210">
            GRAPHIC 1
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s304" data-node-id="1018:211" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="1018:212">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s614" data-node-id="1018:213">
              GRAPHIC 2
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <div className="s16 s81 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s28 s34" data-node-id="772:329" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s152 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="772:330">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s319" data-node-id="772:331">
              UI/UX
            </p>
            <div className="s0 s28 s320" data-node-id="772:332">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgEllipse37} />
            </div>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </div>
        <a className="s16 s141 s17 s305 s18 s311 s307 s316 s309 s0 s145 s146 s28 s34" data-node-id="1018:218" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:219">
            PACKAGE
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s306 s307 s317 s309 s0 s145 s146 s28 s34" data-node-id="1018:220" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:221">
            MOTION
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
      </div>
      <div className="s2 s615 s260 s616" data-node-id="1035:571" data-name="DING_UIUX 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingUiux1} />
      </div>
    </div>
  );
}